import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { A2AIpAllowlist } from './a2a-ip-allowlist-types';

export const getA2AIpAllowlist = async (): Promise<A2AIpAllowlist | null> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('No organization selected');
  }

  const response = await apiRequest<A2AIpAllowlist>({
    url: `/organizations/${orgId}/a2a-ip-allowlist`,
    method: 'GET',
    target: 'platform',
    suppressSentryStatuses: [404],
  });

  // Only a 404 that names the allowlist means it has never been configured for
  // this org. Other 404s (unknown org, unrouted/undeployed endpoint) are real
  // errors and must surface rather than render as "no restrictions configured".
  if (
    response?.statusCode === 404 &&
    response.detail?.toLowerCase().includes('allowlist')
  ) {
    return null;
  }

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to get A2A IP allowlist');
  }

  return response.data ?? null;
};
